import createIcon from '../../createIcon';

/**
 * @component @name Abc
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMTFIMTkuNVYxMC41SDE3LjVWMTMuNUgxOS41VjEzSDIxVjE0QzIxIDE0LjU1IDIwLjU1IDE1IDIwIDE1SDE3QzE2LjQ1IDE1IDE2IDE0LjU1IDE2IDE0VjEwQzE2IDkuNDUgMTYuNDUgOSAxNyA5SDIwQzIwLjU1IDkgMjEgOS40NSAyMSAxMFYxMVpNOCAxMFYxNUg2LjVWMTMuNUg0LjVWMTVIM1YxMEMzIDkuNDUgMy40NSA5IDQgOUg3QzcuNTUgOSA4IDkuNDUgOCAxMFpNNi41IDEwLjVINC41VjEySDYuNVYxMC41Wk0xMy41IDEyQzE0LjA1IDEyIDE0LjUgMTIuNDUgMTQuNSAxM1YxNEMxNC41IDE0LjU1IDE0LjA1IDE1IDEzLjUgMTVIOS41VjlIMTMuNUMxNC4wNSA5IDE0LjUgOS40NSAxNC41IDEwVjExQzE0LjUgMTEuNTUgMTQuMDUgMTIgMTMuNSAxMlpNMTEgMTAuNVYxMS4yNUgxM1YxMC41SDExWk0xMyAxMi43NUgxMVYxMy41SDEzVjEyLjc1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Abc = createIcon('Abc', [
  [
    'path',
    {
      d: 'M21 11H19.5V10.5H17.5V13.5H19.5V13H21V14C21 14.55 20.55 15 20 15H17C16.45 15 16 14.55 16 14V10C16 9.45 16.45 9 17 9H20C20.55 9 21 9.45 21 10V11ZM8 10V15H6.5V13.5H4.5V15H3V10C3 9.45 3.45 9 4 9H7C7.55 9 8 9.45 8 10ZM6.5 10.5H4.5V12H6.5V10.5ZM13.5 12C14.05 12 14.5 12.45 14.5 13V14C14.5 14.55 14.05 15 13.5 15H9.5V9H13.5C14.05 9 14.5 9.45 14.5 10V11C14.5 11.55 14.05 12 13.5 12ZM11 10.5V11.25H13V10.5H11ZM13 12.75H11V13.5H13V12.75Z',
      key: '1r2gkz',
    },
  ],
]);

export default Abc;
